import request from '@/utils/request'

export function net(url, method, params = {}) {

	return new Promise((re, rj) => {
		switch (method) {
			case 'postZip':
				re(requestPostZip(url, params))
				break
			case 'post':
				re(requestPost(url, params))
				break
			case 'get':
				re(requestGet(url, params))
				break
			case 'delete':
				re(requestDelete(url, params))
				break
			case 'deleteData':
				re(requestDeleteData(url, params))
				break
			case 'put':
				re(requestPut(url, params))
				break
			case 'putZip':
				re(requestPutZip(url, params))
				break
			case 'postFile'://导出文档
				re(requestPostFile(url, params))
				break
			case 'getFile'://导出文档
				re(requestGetFile(url, params))
				break
		}
	})
}
function requestGetFile(url, data) {
	return request({
		url,
		method: 'get',
		params: data,
		responseType: 'blob',
	})
}

function requestPostFile(url, data) {
	return request({
		url,
		method: 'post',
		data,
		responseType: 'blob',
	})
}
function requestPost(url, data) {
	return request({
		url,
		method: 'post',
		data
	})
}

function requestPostZip(url, data) {
	return request({
		url,
		method: 'post',
		data,
		headers: { 'Content-Encoding': 'gzip', 'Content-Type': 'application/json' }
	})
}

function requestGet(url, params) {
	return request({
		url,
		method: 'get',
		params
	})
}

function requestDelete(url, params) {
	return request({
		url,
		method: 'delete',
		data: params
	})
}

function requestDeleteData(url, params) {
	return request({
		url,
		method: 'delete',
		data: params
	})
}

function requestPut(url, data) {
	return request({
		url,
		method: 'put',
		data
	})
}
function requestPutZip(url, data) {
	return request({
		url,
		method: 'put',
		data,
		headers: { 'Content-Encoding': 'gzip', 'Content-Type': 'application/json' }
	})
}

